import React from "react";
import CdxToolTip from "../CdxToolTip";

const SolutionItem = (props) => {
  //  const loggedInUser = useSelector((state) => state.auth.loggedInUser);

  return (
    <div className={"d-flex " + props.className}>
      {props.thumbnail !== null &&
        props.thumbnail !== "" &&
        props.thumbnail !== undefined && (
          <div
            className="solution-thumbnail 1"
            style={{ backgroundImage: `url("${props.thumbnail}")` }}
          ></div>
        )}
      {(props.thumbnail === null ||
        props.thumbnail === "" ||
        props.thumbnail === undefined) && (
          <div className="solution-thumbnail 2"></div>
        )}
      <div className="solution-content">
        <div>
          <div className="solutionName">{props.solutionName}</div>
          <div className="team-info">
            <div className="teamName">{props.teamName}</div>
            <div className="team-info-divider" />
            <div className="team-total-ratings">
              <CdxToolTip
                trigger={['hover', 'focus']}
                placement="bottom-start"
                content={"Average Rating from Mission Directors"}  >
                <div className="d-flex align-items-center gap-10">
                  {props.totalRating}<span className="totalRatingStar" />
                </div>
              </CdxToolTip>
              {/* {props.totalRating}<span className="totalRatingStar" /> */}
            </div>
          </div>
          <div className="solutionBrief">
            {props.shortDescription.length > 150
              ? props.shortDescription.substring(0, 150) + "..."
              : props.shortDescription}
          </div>
        </div>
        <div className="likeCommentDiv">
          <div className="like-comment-wrapper">
            <div className="likeDiv">
              {props.isLiked && <div className="likeIcon" style={{ cursor: "default" }}></div>}
              {!props.isLiked && <div className="unlikeIcon" style={{ cursor: "default" }}></div>}
              <div className="likeCount">{props.likeCount}</div>
            </div>

            <div className="commentDiv">
              <div className="commentIcon"></div>
              <div className="commentCount">{props.commentCount}</div>
            </div>
          </div>

          <div className="commentDiv">
            <button
              className="cdx-btn"
              disabled={props.isRated}
              onClick={() => {
                props.openRatingModal(props.id);
              }}
            >
              {props.button}
            </button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default SolutionItem;
